var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-form",
            {
              ref: "modifyForm",
              attrs: { model: _vm.modifyForm, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "字段", prop: "region" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.region,
                        callback: function ($$v) {
                          _vm.region = $$v
                        },
                        expression: "region",
                      },
                    },
                    _vm._l(_vm.elLists, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "字段内容" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.contentChange },
                      model: {
                        value: _vm.content,
                        callback: function ($$v) {
                          _vm.content = $$v
                        },
                        expression: "content",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "empty" } }, [
                        _vm._v("清空内容"),
                      ]),
                      _c("el-radio", { attrs: { label: "edit" } }, [
                        _vm._v("修改为新值"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.region === "isConventionalMaterials" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "isConventionalMaterials" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择非常规物料标识",
                            clearable: "",
                          },
                          model: {
                            value: _vm.modifyForm.isConventionalMaterials,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.modifyForm,
                                "isConventionalMaterials",
                                $$v
                              )
                            },
                            expression: "modifyForm.isConventionalMaterials",
                          },
                        },
                        _vm._l(
                          _vm.isConventionalMaterialsLists,
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "dcs" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "dcs" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "multiple_sel",
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            multiple: "",
                            filterable: "",
                            placeholder: "请选择DCs",
                          },
                          model: {
                            value: _vm.modifyForm.dcs,
                            callback: function ($$v) {
                              _vm.$set(_vm.modifyForm, "dcs", $$v)
                            },
                            expression: "modifyForm.dcs",
                          },
                        },
                        _vm._l(_vm.dcsLists, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.supplierName,
                              value: item.tmSupplierId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "isLto" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "isLto" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "IS_NOT",
                          placeholder: "请选择是否LTO",
                        },
                        model: {
                          value: _vm.modifyForm.isLto,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "isLto", $$v)
                          },
                          expression: "modifyForm.isLto",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "approvedBy" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "approvedBy" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择提交审批人",
                            clearable: "",
                          },
                          on: { change: _vm.approvedByChange },
                          model: {
                            value: _vm.modifyForm.approvedBy,
                            callback: function ($$v) {
                              _vm.$set(_vm.modifyForm, "approvedBy", $$v)
                            },
                            expression: "modifyForm.approvedBy",
                          },
                        },
                        _vm._l(_vm.leaderList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.userName,
                              value: item.tmUserId,
                            },
                          })
                        }),
                        1
                      ),
                      _c("p", { staticStyle: { color: "#F56C6C" } }, [
                        _vm._v("请根据物料非常规标识和是否LTO选择对应的审批."),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "settlementClassification" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "settlementClassification" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "SETTLEMENT_CLASSIFICATION",
                          placeholder: "请选择结算分类",
                        },
                        model: {
                          value: _vm.modifyForm.settlementClassification,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "settlementClassification",
                              $$v
                            )
                          },
                          expression: "modifyForm.settlementClassification",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "useArea" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "useArea" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "USE_AREA",
                          placeholder: "请选择使用区域",
                        },
                        model: {
                          value: _vm.modifyForm.useArea,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "useArea", $$v)
                          },
                          expression: "modifyForm.useArea",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "originCountry" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "originCountry" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "10",
                          clearable: "",
                          placeholder: "请输入原产地",
                        },
                        model: {
                          value: _vm.modifyForm.originCountry,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "originCountry",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.originCountry",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "minimumOrders" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "minimumOrders" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                          placeholder: "请输入最小订单量",
                        },
                        model: {
                          value: _vm.modifyForm.minimumOrders,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "minimumOrders",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.minimumOrders",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "minimumOrderUnit" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "minimumOrderUnit" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "MINIMUM_ORDER_UNIT",
                          placeholder: "请选择最小订单单位",
                        },
                        model: {
                          value: _vm.modifyForm.minimumOrderUnit,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "minimumOrderUnit", $$v)
                          },
                          expression: "modifyForm.minimumOrderUnit",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "isTraceable" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "isTraceable" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "IS_NOT",
                          placeholder: "请选择是否可追溯",
                        },
                        model: {
                          value: _vm.modifyForm.isTraceable,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "isTraceable", $$v)
                          },
                          expression: "modifyForm.isTraceable",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "enterCatellaeSystem" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "enterCatellaeSystem" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "IS_NOT",
                          placeholder: "请选择是否进入Catellae系统",
                        },
                        model: {
                          value: _vm.modifyForm.enterCatellaeSystem,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "enterCatellaeSystem", $$v)
                          },
                          expression: "modifyForm.enterCatellaeSystem",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "temperature" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "temperature" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "COMMON",
                          field: "TEMPERATURE",
                          placeholder: "请选择储存环境",
                        },
                        model: {
                          value: _vm.modifyForm.temperature,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "temperature", $$v)
                          },
                          expression: "modifyForm.temperature",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "validityDate" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "validityDate" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "VALIDITY_DATE",
                          placeholder: "请选择有效期检查",
                        },
                        model: {
                          value: _vm.modifyForm.validityDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "validityDate", $$v)
                          },
                          expression: "modifyForm.validityDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "minimumStorageTemperature" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "minimumStorageTemperature" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: "10",
                          placeholder: "请输入最低保存温度",
                        },
                        model: {
                          value: _vm.modifyForm.minimumStorageTemperature,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "minimumStorageTemperature",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.minimumStorageTemperature",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "maximumStorageTemperature" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "maximumStorageTemperature" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxLength: "10",
                          placeholder: "请输入最高保存温度",
                        },
                        model: {
                          value: _vm.modifyForm.maximumStorageTemperature,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "maximumStorageTemperature",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.maximumStorageTemperature",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "dcManagementUnit" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "dcManagementUnit" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          table: "TM_MATERIAL_RECORD",
                          field: "MCD_BUYING_UNIT",
                          placeholder: "请选择DC库存管理单位",
                        },
                        model: {
                          value: _vm.modifyForm.dcManagementUnit,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "dcManagementUnit", $$v)
                          },
                          expression: "modifyForm.dcManagementUnit",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "productPackagingType" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "productPackagingType" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          table: "TM_MATERIAL_RECORD",
                          field: "PRODUCT_PACKAGING_TYPE",
                          placeholder: "请选择产品外包装类型",
                        },
                        model: {
                          value: _vm.modifyForm.productPackagingType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "productPackagingType",
                              $$v
                            )
                          },
                          expression: "modifyForm.productPackagingType",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "externalPackagingLength" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "externalPackagingLength" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.externalPackagingLength = _vm.onBlur(
                              _vm.modifyForm.externalPackagingLength,
                              2
                            )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.externalPackagingLength =
                              _vm.onInput(
                                _vm.modifyForm.externalPackagingLength
                              )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.externalPackagingLength,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "externalPackagingLength",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.externalPackagingLength",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "externalPackagingWidth" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "externalPackagingWidth" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.externalPackagingWidth = _vm.onBlur(
                              _vm.modifyForm.externalPackagingWidth,
                              2
                            )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.externalPackagingWidth = _vm.onInput(
                              _vm.modifyForm.externalPackagingWidth
                            )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.externalPackagingWidth,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "externalPackagingWidth",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.externalPackagingWidth",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "externalPackagingHeight" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "externalPackagingHeight" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.externalPackagingHeight = _vm.onBlur(
                              _vm.modifyForm.externalPackagingHeight,
                              2
                            )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.externalPackagingHeight =
                              _vm.onInput(
                                _vm.modifyForm.externalPackagingHeight
                              )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.externalPackagingHeight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "externalPackagingHeight",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.externalPackagingHeight",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "externalPackagingNetweight" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "externalPackagingNetweight" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.externalPackagingNetweight =
                              _vm.externalPackagingNetweightBlur(
                                _vm.modifyForm.externalPackagingNetweight,
                                3
                              )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.externalPackagingNetweight =
                              _vm.onInput2(
                                _vm.modifyForm.externalPackagingNetweight
                              )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.externalPackagingNetweight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "externalPackagingNetweight",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.externalPackagingNetweight",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "externalPackagingGrossweight" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "externalPackagingGrossweight" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.externalPackagingGrossweight =
                              _vm.externalPackagingGrossweightBlur(
                                _vm.modifyForm.externalPackagingGrossweight,
                                3
                              )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.externalPackagingGrossweight =
                              _vm.onInput2(
                                _vm.modifyForm.externalPackagingGrossweight
                              )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.externalPackagingGrossweight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "externalPackagingGrossweight",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.externalPackagingGrossweight",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "palletLayerBoxNumber" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "palletLayerBoxNumber" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.modifyForm.palletLayerBoxNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "palletLayerBoxNumber",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.palletLayerBoxNumber",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "palletLayerNumber" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "palletLayerNumber" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.modifyForm.palletLayerNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "palletLayerNumber",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.palletLayerNumber",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "palletItemsLength" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "palletItemsLength" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.palletItemsLength =
                              _vm.blurPalletItemsLength(
                                _vm.modifyForm.palletItemsLength,
                                2
                              )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.palletItemsLength = _vm.onInput(
                              _vm.modifyForm.palletItemsLength
                            )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.palletItemsLength,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "palletItemsLength",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.palletItemsLength",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "palletItemsWidth" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "palletItemsWidth" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.palletItemsWidth =
                              _vm.blurPalletItemsWidth(
                                _vm.modifyForm.palletItemsWidth,
                                2
                              )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.palletItemsWidth = _vm.onInput(
                              _vm.modifyForm.palletItemsWidth
                            )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.palletItemsWidth,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "palletItemsWidth",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.palletItemsWidth",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "palletItemsHeight" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "palletItemsHeight" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        on: {
                          blur: function ($event) {
                            _vm.modifyForm.palletItemsHeight =
                              _vm.blurPalletItemsHeight(
                                _vm.modifyForm.palletItemsHeight,
                                2
                              )
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            _vm.modifyForm.palletItemsHeight = _vm.onInput(
                              _vm.modifyForm.palletItemsHeight
                            )
                          },
                        },
                        model: {
                          value: _vm.modifyForm.palletItemsHeight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "palletItemsHeight",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.palletItemsHeight",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "storageHeight" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "storageHeight" } },
                    [
                      _c("el-input", {
                        attrs: {
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                          placeholder: "请输入存储高度",
                        },
                        model: {
                          value: _vm.modifyForm.storageHeight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "storageHeight",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.storageHeight",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "minimumDcReceivingValidity" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "minimumDcReceivingValidity" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                          placeholder: "请输入最小DC收货有效期(天)",
                        },
                        model: {
                          value: _vm.modifyForm.minimumDcReceivingValidity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.modifyForm,
                              "minimumDcReceivingValidity",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modifyForm.minimumDcReceivingValidity",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.region === "isFresh" && _vm.isNotEmpty
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "isFresh" } },
                    [
                      _c("ic-select", {
                        attrs: {
                          clearable: "",
                          table: "TM_MATERIAL_RECORD",
                          field: "IS_NOT",
                          placeholder: "请选择是否鲜货",
                        },
                        model: {
                          value: _vm.modifyForm.isFresh,
                          callback: function ($$v) {
                            _vm.$set(_vm.modifyForm, "isFresh", $$v)
                          },
                          expression: "modifyForm.isFresh",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("确定")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }